import { createFileRoute } from "@tanstack/react-router";
import { StrukturaListPage } from "@/features/sys-premiowy/struktura-list-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/raporty/system-premiowy/struktura/")({
	component: StrukturaListPage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.raporty.sys-premiowy-struktura",
			location.pathname,
		);
	},
});
